<template>
  <label
    class="checkbox-wrapper"
    :class="{ disabled: disabled, checked: checked }"
  >
    <input
      :id="id"
      type="checkbox"
      :disabled="disabled"
      :checked="checked"
      @change="onChange"
    />
    <span class="checkbox" :style="{ height: `${size}px`, width: `${size}px` }">
      <check-icon :size="size" />
    </span>
    <span class="label" v-if="label">{{ label }}</span>
  </label>
</template>

<script>
  import { CheckIcon } from "vue-feather-icons";

  export default {
    name: "Checkbox",
    props: {
      id: String,
      checked: {
        type: Boolean,
        default: false
      },
      label: String,
      disabled: Boolean,
      size: {
        type: String,
        default: "18"
      }
    },
    methods: {
      onChange(event) {
        this.$emit("change", event.target.checked);
      }
    },
    components: {
      CheckIcon
    }
  };
</script>

<style scoped lang="scss">
  .checkbox-wrapper {
    display: flex;
    align-items: center;
    position: relative;
    
    > input {
      opacity: 0;
      position: absolute;
      z-index: 1;
      &:focus {
        + .checkbox {
          box-shadow: 0 0 5px $color-secondary;
          border-color: $color-secondary;
        }
      }
      &:hover {
        cursor: pointer;
      }
    }
    .checkbox {
      line-height: 1em;
      border: 1px solid #aeb7bf;
      border-radius: 2px;
      display: inline-block;
      transition: all 0.2s ease-in-out;
      position: relative;
      z-index: 2;
      svg {
        opacity: 0;
        display: block;
      }
    }

    .label {
      margin-left: 8px;
    }
    
    &.checked {
      .checkbox {
        background: $color-secondary;
        border-color: $color-secondary;
        color: #fff;
        svg {
          opacity: 1;
        }
      }
      > input:focus + .checkbox {
        box-shadow: 0 0 10px $color-secondary;
      }
    }
    &.disabled {
      color: #ddd;
      .checkbox {
        background: #ddd;
        border-color: #ddd;
        color: #888;
      }
      &:hover {
        cursor: not-allowed;
      }
    }
    &:hover {
      cursor: pointer;
    }
  }
</style>
